module.exports = __webpack_public_path__ + "static/media/ic-roomservice.1c6dad02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-roomservice.svg
// module id = 657
// module chunks = 14